import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

const ProductsByCategory = () => {
  const { categoryId } = useParams();
  const [products, setProducts] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const prodRes = await axios.get(
          "https://api.vyapakprint.com/api/businessProducts/getAllBusinessProducts"
        );
        const filtered = prodRes.data.filter(
          (p) => p.category?._id === categoryId
        );
        setProducts(filtered);
      } catch (err) {
        console.error("Failed to fetch products:", err);
      } finally {
        setLoading(false);
      }
    };

    const fetchCategory = async () => {
      try {
        const res = await axios.get(
          "https://api.vyapakprint.com/api/category-options"
        );
        const found = res.data.options?.find((c) => c._id === categoryId);
        setCategoryName(found?.name || "Category");
      } catch (err) {
        console.error("Failed to fetch category:", err);
      }
    };

    fetchProducts();
    fetchCategory();
  }, [categoryId]);

  if (loading) return <p className="text-center py-10">Loading products…</p>;

  return (
    <div className="container mx-auto px-6 py-8">
      <h2 className="text-2xl font-semibold mb-6 text-center">
        Products in "{categoryName}"
      </h2>

      {products.length === 0 ? (
        <p className="text-center text-gray-500">No products found.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {products.map((product) => (
            <Link
              key={product._id}
              to={`/create-order/${product._id}`}
              className="bg-white p-4 rounded-lg shadow hover:shadow-md"
            >
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-40 object-cover rounded-md mb-3"
              />
              <h3 className="font-semibold text-lg">{product.name}</h3>
              <p className="text-sm text-gray-600 mt-1">
                Dispatch Time: {product.shippingTime}
              </p>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductsByCategory;
